import {
  updateEnquire,
  updateGetHelp,
  updatePropertyData,
  updatePropertyRoom,
  updatePropertyTenancy,
} from "@App/userHistoryReducer";
import { HAPPY_FLOW_TENANCY_CTAS } from "constants/index";
import { Dispatch } from "react";
import { OPENING_SOURCE } from "../constants";
import getActionInitiatedData from "./getActionInitiatedData";

const updateInventoryData = ({
  openingSource,
  regionCanonicalName,
  dispatch,
  inventory,
  propertyId,
}: {
  openingSource: string;
  regionCanonicalName: string;
  dispatch: Dispatch<any>;
  inventory: any;
  propertyId: number;
}) => {
  const {
    GET_HELP,
    SEARCH_INVENTORY_ENQUIRE,
    CLICKED_BOOK_ENQUIRE_NOW_PROPERTY,
    CONTACT_US,
    BOOK_NOW,
    JOIN_WAITLIST,
    QUESTION_ENQUIRY_CONNECT_CTA,
    FAQ_QUESTION_CTA,
    APPLY_FOR_FALL,
  } = OPENING_SOURCE;

  if (openingSource === GET_HELP) {
    dispatch(updateGetHelp({ regionCanonicalName }));
  } else if (
    openingSource === SEARCH_INVENTORY_ENQUIRE ||
    openingSource === CLICKED_BOOK_ENQUIRE_NOW_PROPERTY ||
    openingSource === QUESTION_ENQUIRY_CONNECT_CTA ||
    openingSource === FAQ_QUESTION_CTA
  ) {
    dispatch(updateEnquire({ inventoryId: inventory.id }));
    dispatch(updatePropertyData({ inventoryId: inventory.id }));
  } else if (
    openingSource === BOOK_NOW ||
    openingSource === JOIN_WAITLIST ||
    openingSource === CONTACT_US ||
    openingSource === APPLY_FOR_FALL
  ) {
    if (openingSource !== BOOK_NOW) {
      dispatch(updateEnquire({ inventoryId: inventory.id }));
      dispatch(updatePropertyData({ inventoryId: inventory.id }));
    }

    let isTenancy = false;
    if (inventory?.parent_id) isTenancy = inventory.parent_id !== propertyId;
    else if (inventory?.config?.parent_id) isTenancy = inventory.config.parent_id !== propertyId;
    else if (inventory?.parent?.id) isTenancy = inventory?.parent?.id !== propertyId;

    const bookFormInitiated =
      openingSource === BOOK_NOW
        ? getActionInitiatedData({
            inventory,
            label: HAPPY_FLOW_TENANCY_CTAS.CONTINUE_BOOKING,
            isTenancy,
          })
        : null;
    const labelMapping = {
      book_now: HAPPY_FLOW_TENANCY_CTAS.CONTINUE_BOOKING,
      join_waitlist: HAPPY_FLOW_TENANCY_CTAS.WAITLISTED,
      contact_us: HAPPY_FLOW_TENANCY_CTAS.CONTACTED,
      apply_for_fall: HAPPY_FLOW_TENANCY_CTAS.WAITLISTED, // re-work
    };

    // TODO Shraddha - fix conditions for config and parent once booking flow is completed
    if (isTenancy) {
      dispatch(
        updatePropertyTenancy({
          inventoryId: propertyId,
          roomId: inventory.parent_id,
          tenancyId: inventory.id,
          label: labelMapping[openingSource as keyof typeof labelMapping],
          roomLabel:
            inventory?.config?.available || inventory?.available
              ? HAPPY_FLOW_TENANCY_CTAS.CONTACT_US
              : HAPPY_FLOW_TENANCY_CTAS.JOIN_WAITLIST,
          ...(bookFormInitiated ? { bookFormInitiated } : {}),
        }),
      );
    } else {
      dispatch(
        updatePropertyRoom({
          inventoryId: propertyId,
          roomId: inventory.id || inventory?.config?.id,
          label: labelMapping[openingSource as keyof typeof labelMapping],
          ...(bookFormInitiated ? { bookFormInitiated } : {}),
        }),
      );
    }
  }
};

export default updateInventoryData;
